import React from 'react';
import { useNavigate } from 'react-router-dom';
import './BreadcrumbSection.styles.scss';

interface BreadcrumbSectionProps {
  moleculeName?: string;
  searchTerm?: string;
}

const BreadcrumbSection: React.FC<BreadcrumbSectionProps> = ({
  moleculeName = 'Acetaminophen',
  searchTerm: _searchTerm = 'Acetaminophen',
}) => {
  const navigate = useNavigate();

  const handleHomeClick = () => {
    navigate('/bdportal/product-wiki');
  };

  const handleSearchResultsClick = () => {
    navigate(`/bdportal/product-wiki`);
  };

  const breadcrumbItems = [
    { label: 'Home', onClick: handleHomeClick },
    { label: 'Search Results', onClick: handleSearchResultsClick },
    { label: `${moleculeName} (Molecule)`, isActive: true },
  ];

  return (
    <nav className="breadcrumb-section" aria-label="Breadcrumb navigation">
      <div className="container">
        {breadcrumbItems.map((item, index) => (
          <React.Fragment key={index}>
            {item.isActive ? (
              <strong>{item.label}</strong>
            ) : (
              <a
                href="#"
                onClick={e => {
                  e.preventDefault();
                  item.onClick?.();
                }}
              >
                {item.label}
              </a>
            )}
            {index < breadcrumbItems.length - 1 && <span> {'>'} </span>}
          </React.Fragment>
        ))}
      </div>
    </nav>
  );
};

export default BreadcrumbSection;
